import React, { useEffect, useState } from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    Annotation,
} from "react-simple-maps";
import { geoCentroid } from "d3-geo";
import * as turf from '@turf/turf';

const SUBREGIONS = {
    lubelskie: {
        name: "Subregion lubelski",
        color: "#dc2626",
        powiats: [
            "Lublin", "powiat lubelski", "powiat świdnicki",
            "powiat lubartowski", "powiat łęczyński"
        ]
    },
    bialski: {
        name: "Subregion bialski",
        color: "#ea580c",
        powiats: [
            "Biała Podlaska", "powiat bialski", "powiat radzyński",
            "powiat parczewski", "powiat włodawski"
        ]
    },
    chelmsko_zamojski: {
        name: "Subregion chełmsko-zamojski",
        color: "#059669",
        powiats: [
            "Chełm", "Zamość", "powiat chełmski", "powiat zamojski",
            "powiat hrubieszowski", "powiat biłgorajski",
            "powiat tomaszowski", "powiat krasnostawski"
        ]
    },
    pulawski: {
        name: "Subregion puławski",
        color: "#3b82f6",
        powiats: [
            "powiat puławski", "powiat łukowski", "powiat rycki",
            "powiat opolski", "powiat kraśnicki", "powiat janowski"
        ]
    },
    krakowski_obszar_metropolitalny: {
        name: "Krakowski Obszar Metropolitalny",
        color: "#8b5cf6",
        powiats: [
            "Kraków", "powiat bocheński", "powiat krakowski",
            "powiat miechowski", "powiat myślenicki",
            "powiat proszowicki", "powiat wielicki"
        ]
    },
    subregion_tarnowski: {
        name: "Subregion tarnowski",
        color: "#f97316",
        powiats: [
            "Tarnów", "powiat brzeski", "powiat dąbrowski", "powiat tarnowski"
        ]
    },
    subregion_sadecki: {
        name: "Subregion sądecki",
        color: "#10b981",
        powiats: [
            "Nowy Sącz", "powiat gorlicki", "powiat limanowski", "powiat nowosądecki"
        ]
    },
    subregion_podhalanski: {
        name: "Subregion podhalański",
        color: "#3b82f6",
        powiats: [
            "powiat nowotarski", "powiat suski", "powiat tatrzański"
        ]
    },
    malopolska_zachodnia: {
        name: "Małopolska Zachodnia",
        color: "#f43f5e",
        powiats: [
            "powiat chrzanowski", "powiat olkuski", "powiat oświęcimski", "powiat wadowicki"
        ]
    },
    // TUTAJ JUŻ GENEROWANE
    swietokrzyskie_polnocne: {
        name: "Subregion północny",
        color: "#2563eb",
        powiats: [
            "powiat konecki",
            "powiat ostrowiecki",
            "powiat skarżyski",
            "powiat starachowicki"
        ]
    },
    swietokrzyskie_poludniowe: {
        name: "Subregion południowy",
        color: "#16a34a",
        powiats: [
            "powiat buski",
            "powiat kazimierski",
            "powiat pińczowski",
            "powiat staszowski"
        ]
    },
    swietokrzyskie_kieleckie: {
        name: "Subregion kielecki",
        color: "#f97316",
        powiats: [
            "Kielce",
            "powiat kielecki",
            "powiat jędrzejowski",
            "powiat opatowski",
            "powiat sandomierski",
            "powiat włoszczowski"
        ]
    }, podkarpackie_rzeszowski: {
        name: "Subregion rzeszowski",
        color: "#dc2626",
        powiats: [
            "Rzeszów",
            "powiat rzeszowski",
            "powiat dębicki",
            "powiat kolbuszowski",
            "powiat ropczycko-sędziszowski",
            "powiat strzyżowski"
        ]
    },
    podkarpackie_tarnobrzeski: {
        name: "Subregion tarnobrzeski",
        color: "#0891b2",
        powiats: [
            "Tarnobrzeg",
            "powiat stalowowolski",
            "powiat tarnobrzeski",
            "powiat niżański",
            "powiat mielecki"
        ]
    },
    podkarpackie_krosnienski: {
        name: "Subregion krośnieński",
        color: "#7c3aed",
        powiats: [
            "Krosno",
            "Przemyśl",
            "powiat bieszczadzki",
            "powiat brzozowski",
            "powiat jarosławski",
            "powiat jasielski",
            "powiat krośnieński",
            "powiat leski",
            "powiat lubaczowski",
            "powiat przemyski",
            "powiat przeworski",
            "powiat sanocki"
        ]
    },
    bialostocki: {
        name: "Subregion białostocki",
        color: "#f59e0b",
        powiats: [
            "Białystok",
            "powiat białostocki",
            "powiat sokólski"
        ]
    },
    lomzynski: {
        name: "Subregion łomżyński",
        color: "#10b981",
        powiats: [
            "Łomża",
            "powiat łomżyński",
            "powiat kolneński",
            "powiat zambrowski"
        ]
    },
    suwalski: {
        name: "Subregion suwalski",
        color: "#3b82f6",
        powiats: [
            "Suwałki",
            "powiat suwalski",
            "powiat augustowski",
            "powiat sejneński"
        ]
    },
    poludniowy_podlaski: {
        name: "Subregion południowy",
        color: "#ef4444",
        powiats: [
            "powiat bielski",
            "powiat hajnowski",
            "powiat moniecki",
            "powiat siemiatycki",
            "powiat wysokomazowiecki"
        ]
    },
    jeleniogorski: {
        name: "Subregion jeleniogórski",
        color: "#22c55e",
        powiats: [
            "Jelenia Góra",
            "powiat karkonoski",
            "powiat bolesławiecki",
            "powiat jaworski",
            "powiat kamiennogórski",
            "powiat lubański",
            "powiat lwówecki",
            "powiat zgorzelecki",
            "powiat złotoryjski"
        ]
    },
    legnicko_glogowski: {
        name: "Subregion legnicko-głogowski",
        color: "#6366f1",
        powiats: [
            "Legnica",
            "powiat głogowski",
            "powiat górowski",
            "powiat legnicki",
            "powiat lubiński",
            "powiat polkowicki"
        ]
    },
    walbrzyski: {
        name: "Subregion wałbrzyski",
        color: "#f59e0b",
        powiats: [
            "Wałbrzych",
            "powiat dzierżoniowski",
            "powiat kłodzki",
            "powiat świdnicki",
            "powiat wałbrzyski",
            "powiat ząbkowicki"
        ]
    },
    wroclawski: {
        name: "Subregion wrocławski",
        color: "#ef4444",
        powiats: [
            "Wrocław",
            "powiat milicki",
            "powiat oleśnicki",
            "powiat oławski",
            "powiat strzeliński",
            "powiat średzki",
            "powiat trzebnicki",
            "powiat wołowski",
            "powiat wrocławski"
        ]
    },
    bydgosko_torunski: {
        name: "Subregion bydgosko-toruński",
        color: "#3b82f6",
        powiats: [
            "Bydgoszcz",
            "Toruń",
            "powiat bydgoski",
            "powiat toruński"
        ]
    },
    grudziadzki: {
        name: "Subregion grudziądzki",
        color: "#10b981",
        powiats: [
            "Grudziądz",
            "powiat grudziądzki",
            "powiat świecki",
            "powiat wąbrzeski"
        ]
    },
    wloclawski: {
        name: "Subregion włocławski",
        color: "#f97316",
        powiats: [
            "Włocławek",
            "powiat aleksandrowski",
            "powiat lipnowski",
            "powiat radziejowski",
            "powiat włocławski"
        ]
    },
    inowroclawski: {
        name: "Subregion inowrocławski",
        color: "#ec4899",
        powiats: [
            "powiat inowrocławski",
            "powiat mogileński",
            "powiat nakielski",
            "powiat sępoleński",
            "powiat tucholski",
            "powiat żniński"
        ]
    },
    gorzowski: {
        name: "Subregion gorzowski",
        color: "#22c55e",
        powiats: [
            "Gorzów Wielkopolski",
            "powiat gorzowski",
            "powiat międzyrzecki",
            "powiat słubicki",
            "powiat strzelecko-drezdenecki",
            "powiat sulęciński"
        ]
    },
    zielonogorski: {
        name: "Subregion zielonogórski",
        color: "#3b82f6",
        powiats: [
            "Zielona Góra",
            "powiat krośnieński",
            "powiat nowosolski",
            "powiat świebodziński",
            "powiat wschowski",
            "powiat zielonogórski",
            "powiat żagański",
            "powiat żarski"
        ]
    },
    lodzki: {
        name: "Subregion łódzki",
        color: "#ef4444",
        powiats: [
            "Łódź",
            "powiat brzeziński",
            "powiat łódzki wschodni",
            "powiat pabianicki",
            "powiat zgierski"
        ]
    },
    piotrkowski: {
        name: "Subregion piotrkowski",
        color: "#f59e0b",
        powiats: [
            "Piotrków Trybunalski",
            "powiat bełchatowski",
            "powiat opoczyński",
            "powiat piotrkowski",
            "powiat radomszczański",
            "powiat tomaszowski"
        ]
    },
    sieradzki: {
        name: "Subregion sieradzki",
        color: "#10b981",
        powiats: [
            "Sieradz",
            "powiat łaski",
            "powiat pajęczański",
            "powiat poddębicki",
            "powiat sieradzki",
            "powiat wieluński",
            "powiat wieruszowski",
            "powiat zduńskowolski"
        ]
    },
    skierniewicki: {
        name: "Subregion skierniewicki",
        color: "#6366f1",
        powiats: [
            "Skierniewice",
            "powiat kutnowski",
            "powiat łęczycki",
            "powiat łowicki",
            "powiat rawski",
            "powiat skierniewicki"
        ]
    },
    warszawski_stoleczny: {
        name: "Subregion warszawski stołeczny",
        color: "#ef4444",
        powiats: [
            "Warszawa"
        ]
    },
    warszawski_wschodni: {
        name: "Subregion warszawski wschodni",
        color: "#f97316",
        powiats: [
            "powiat miński",
            "powiat otwocki",
            "powiat wołomiński",
            "powiat legionowski",
            "powiat nowodworski"
        ]
    },
    warszawski_zachodni: {
        name: "Subregion warszawski zachodni",
        color: "#3b82f6",
        powiats: [
            "powiat grodziski",
            "powiat pruszkowski",
            "powiat warszawski zachodni",
            "powiat żyrardowski",
            "powiat piaseczyński"
        ]
    },
    ciechanowski: {
        name: "Subregion ciechanowski",
        color: "#22c55e",
        powiats: [
            "powiat ciechanowski",
            "powiat mławski",
            "powiat płoński",
            "powiat pułtuski",
            "powiat żuromiński"
        ]
    },
    ostrolecki: {
        name: "Subregion ostrołęcki",
        color: "#06b6d4",
        powiats: [
            "Ostrołęka",
            "powiat ostrołęcki",
            "powiat makowski",
            "powiat przasnyski",
            "powiat ostrowski",
            "powiat wyszkowski"
        ]
    },
    radomski: {
        name: "Subregion radomski",
        color: "#a855f7",
        powiats: [
            "Radom",
            "powiat radomski",
            "powiat białobrzeski",
            "powiat kozienicki",
            "powiat lipski",
            "powiat przysuski",
            "powiat szydłowiecki",
            "powiat zwoleński"
        ]
    },
    siedlecki: {
        name: "Subregion siedlecki",
        color: "#10b981",
        powiats: [
            "Siedlce",
            "powiat siedlecki",
            "powiat garwoliński",
            "powiat łosicki",
            "powiat sokołowski",
            "powiat węgrowski"
        ]
    },
    plocki: {
        name: "Subregion płocki",
        color: "#f59e0b",
        powiats: [
            "Płock",
            "powiat płocki",
            "powiat gostyniński",
            "powiat sierpecki"
        ]
    },
    opolski: {
        name: "Subregion opolski",
        color: "#ef4444",
        powiats: [
            "Opole",
            "powiat opolski",
            "powiat krapkowicki",
            "powiat strzelecki"
        ]
    },
    nyski: {
        name: "Subregion nyski",
        color: "#22c55e",
        powiats: [
            "powiat nyski",
            "powiat brzeski",
            "powiat prudnicki",
            "powiat głubczycki"
        ]
    },
    północny_opolski: {
        name: "Subregion północny",
        color: "#3b82f6",
        powiats: [
            "powiat kluczborski",
            "powiat namysłowski",
            "powiat oleski"
        ]
    },
    trojmiejski: {
        name: "Subregion trójmiejski",
        color: "#3b82f6",
        powiats: [
            "Gdańsk",
            "Gdynia",
            "Sopot"
        ]
    },
    gdanski: {
        name: "Subregion gdański",
        color: "#22c55e",
        powiats: [
            "powiat gdański",
            "powiat kartuski",
            "powiat nowodworski",
            "powiat pucki",
            "powiat wejherowski"
        ]
    },
    slupski: {
        name: "Subregion słupski",
        color: "#f97316",
        powiats: [
            "Słupsk",
            "powiat słupski",
            "powiat bytowski",
            "powiat lęborski"
        ]
    },
    starogardzki: {
        name: "Subregion starogardzki",
        color: "#10b981",
        powiats: [
            "powiat starogardzki",
            "powiat chojnicki",
            "powiat człuchowski",
            "powiat kościerski",
            "powiat tczewski"
        ]
    },
    malborski: {
        name: "Subregion malborski",
        color: "#a855f7",
        powiats: [
            "powiat malborski",
            "powiat sztumski",
            "powiat kwidzyński"
        ]
    },
    centralny_slaski: {
        name: "Subregion centralny",
        color: "#ef4444",
        powiats: [
            "Katowice",
            "Bytom",
            "Chorzów",
            "Dąbrowa Górnicza",
            "Gliwice",
            "Jastrzębie-Zdrój",
            "Mysłowice",
            "Piekary Śląskie",
            "Ruda Śląska",
            "Siemianowice Śląskie",
            "Sosnowiec",
            "Świętochłowice",
            "Tychy",
            "Zabrze"
        ]
    },
    polnocny_slaski: {
        name: "Subregion północny",
        color: "#22c55e",
        powiats: [
            "Częstochowa",
            "powiat częstochowski",
            "powiat kłobucki",
            "powiat lubliniecki",
            "powiat myszkowski"
        ]
    },
    poludniowy_slaski: {
        name: "Subregion południowy",
        color: "#3b82f6",
        powiats: [
            "Bielsko-Biała",
            "powiat bielski",
            "powiat cieszyński",
            "powiat żywiecki"
        ]
    },
    zachodni_slaski: {
        name: "Subregion zachodni",
        color: "#f97316",
        powiats: [
            "Rybnik",
            "Żory",
            "powiat raciborski",
            "powiat rybnicki",
            "powiat wodzisławski"
        ]
    },
    poznanski: {
        name: "Subregion poznański",
        color: "#ef4444",
        powiats: [
            "Poznań",
            "powiat poznański",
            "powiat obornicki",
            "powiat szamotulski",
            "powiat średzki",
            "powiat śremski",
            "powiat wrzesiński"
        ]
    },
    pilski: {
        name: "Subregion pilski",
        color: "#3b82f6",
        powiats: [
            "Piła",
            "powiat pilski",
            "powiat chodzieski",
            "powiat czarnkowsko-trzcianecki",
            "powiat wągrowiecki",
            "powiat złotowski"
        ]
    },
    kaliski: {
        name: "Subregion kaliski",
        color: "#22c55e",
        powiats: [
            "Kalisz",
            "powiat kaliski",
            "powiat jarociński",
            "powiat kępiński",
            "powiat ostrowski",
            "powiat ostrzeszowski",
            "powiat pleszewski"
        ]
    },
    koniński: {
        name: "Subregion koniński",
        color: "#f97316",
        powiats: [
            "Konin",
            "powiat koniński",
            "powiat kolski",
            "powiat słupecki",
            "powiat turecki"
        ]
    },
    leszczynski: {
        name: "Subregion leszczyński",
        color: "#10b981",
        powiats: [
            "Leszno",
            "powiat leszczyński",
            "powiat gostyński",
            "powiat grodziski",
            "powiat kościański",
            "powiat rawicki",
            "powiat wolsztyński"
        ]
    },
    szczecinski: {
        name: "Subregion szczeciński",
        color: "#3b82f6",
        powiats: [
            "Szczecin",
            "powiat policki",
            "powiat goleniowski",
            "powiat gryfiński"
        ]
    },
    koszalinski: {
        name: "Subregion koszaliński",
        color: "#22c55e",
        powiats: [
            "Koszalin",
            "powiat koszaliński",
            "powiat białogardzki",
            "powiat kołobrzeski",
            "powiat sławieński",
            "powiat szczecinecki",
            "powiat świdwiński"
        ]
    },
    szczecinecko_pyrzycki: {
        name: "Subregion wschodni",
        color: "#f97316",
        powiats: [
            "powiat choszczeński",
            "powiat drawski",
            "powiat gryficki",
            "powiat kamieński",
            "powiat łobeski",
            "powiat myśliborski",
            "powiat pyrzycki",
            "powiat stargardzki",
            "powiat wałecki"
        ]
    },
    olsztynski: {
        name: "Subregion olsztyński",
        color: "#ef4444",
        powiats: [
            "Olsztyn",
            "powiat olsztyński",
            "powiat bartoszycki",
            "powiat kętrzyński",
            "powiat lidzbarski",
            "powiat mrągowski",
            "powiat szczycieński"
        ]
    },
    elblaski: {
        name: "Subregion elbląski",
        color: "#3b82f6",
        powiats: [
            "Elbląg",
            "powiat elbląski",
            "powiat braniewski",
            "powiat działdowski",
            "powiat iławski",
            "powiat nowomiejski",
            "powiat ostródzki"
        ]
    },
    elkowski: {
        name: "Subregion ełcki",
        color: "#22c55e",
        powiats: [
            "Ełk",
            "powiat ełcki",
            "powiat giżycki",
            "powiat gołdapski",
            "powiat olecki",
            "powiat piski",
            "powiat węgorzewski"
        ]
    },
    jeleniogorski: {
        name: "Subregion jeleniogórski",
        color: "#22c55e",
        powiats: [
            "Jelenia Góra",
            "powiat karkonoski",
            "powiat bolesławiecki",
            "powiat jaworski",
            "powiat kamiennogórski",
            "powiat lubański",
            "powiat lwówecki",
            "powiat zgorzelecki",
            "powiat złotoryjski"
        ]
    },
    legnicko_glogowski: {
        name: "Subregion legnicko-głogowski",
        color: "#6366f1",
        powiats: [
            "Legnica",
            "powiat głogowski",
            "powiat górowski",
            "powiat legnicki",
            "powiat lubiński",
            "powiat polkowicki"
        ]
    },
    walbrzyski: {
        name: "Subregion wałbrzyski",
        color: "#f59e0b",
        powiats: [
            "Wałbrzych",
            "powiat dzierżoniowski",
            "powiat kłodzki",
            "powiat świdnicki",
            "powiat wałbrzyski",
            "powiat ząbkowicki"
        ]
    },
    wroclawski: {
        name: "Subregion wrocławski",
        color: "#ef4444",
        powiats: [
            "Wrocław",
            "powiat milicki",
            "powiat oleśnicki",
            "powiat oławski",
            "powiat strzeliński",
            "powiat średzki",
            "powiat trzebnicki",
            "powiat wołowski",
            "powiat wrocławski"
        ]
    }
};

export default function SelectionMap({ location }) {
    const [geoData, setGeoData] = useState(null);
    const [selectedPowiatId, setSelectedPowiatId] = useState(null);
    const [selectedPowiatName, setSelectedPowiatName] = useState(null);
    const [hoveredPowiatId, setHoveredPowiatId] = useState(null);
    const [selectedSubregion, setSelectedSubregion] = useState(null);
    const [subregionCenter, setSubregionCenter] = useState(null);
    const [polandPowiatFeatures, setPolandPowiatFeatures] = useState([]);

    const SUBREGION_MAX_DISTANCE_KM = 130;

    useEffect(() => {
        fetch("/powiaty.geojson")
            .then((res) => res.json())
            .then((data) => {
                const plFeatures = data.features.filter(f =>
                    f.properties?.nazwa &&
                    f.properties.nazwa.toLowerCase().includes('powiat')
                );
                console.log(`Znaleziono ${plFeatures.length} powiatów`);
                setPolandPowiatFeatures(plFeatures);
                setGeoData({ type: "FeatureCollection", features: plFeatures });
            })
            .catch((err) => console.error("Błąd:", err));
    }, []);

    useEffect(() => {
        const selectPowiatFromLocation = async () => {
            if (!location?.county || !polandPowiatFeatures.length) return;

            const query = `${location.county} powiat ${location.voivodeship} Poland`;
            try {
                const res = await fetch(
                    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=3&countrycodes=pl&addressdetails=1`
                );
                const geoResults = await res.json();

                for (const geo of geoResults) {
                    const point = turf.point([parseFloat(geo.lon), parseFloat(geo.lat)]);
                    const powiatFeature = polandPowiatFeatures.find(f => turf.booleanPointInPolygon(point, f));
                    if (powiatFeature) {
                        console.log('powiatFeature.properties', powiatFeature.properties);
                        const name = getPowiatName(powiatFeature.properties);
                        const id = getPowiatId(powiatFeature.properties);
                        setSelectedPowiatId(id);
                        setSelectedPowiatName(name);
                        const subregion = getSubregionFromPowiat(name);
                        if (subregion) {
                            setSelectedSubregion(subregion);
                            const center = turf.centerOfMass(powiatFeature);
                            setSubregionCenter(center);
                        }
                        return;
                    }
                }
            } catch (err) {
                console.error("Błąd geokodowania:", err);
            }
        };

        selectPowiatFromLocation();
    }, [location, polandPowiatFeatures]);

    const getPowiatName = (properties) => {
        return properties.nazwa?.toLowerCase() || properties.NAME?.toLowerCase() || "";
    };

    const getPowiatId = (properties) => {
        return properties.id || null;
    };

    const getSubregionFromPowiat = (powiatName) => {
        const lowerName = powiatName.toLowerCase();
        for (const [key, subregion] of Object.entries(SUBREGIONS)) {
            if (subregion.powiats.some(powiat =>
                lowerName.includes(powiat.toLowerCase()) ||
                lowerName === powiat.toLowerCase()
            )) {
                return key;
            }
        }
        return null;
    };

    const isInSelectedSubregionSpatially = (feature) => {
        if (!selectedSubregion || !subregionCenter) return false;

        const name = getPowiatName(feature.properties);
        const subKey = getSubregionFromPowiat(name);
        if (subKey !== selectedSubregion) return false;

        const centroid = turf.centroid(feature);
        const dist = turf.distance(subregionCenter, centroid, { units: "kilometers" });

        return dist <= SUBREGION_MAX_DISTANCE_KM;
    };

    if (!geoData) return <div>Ładowanie mapy subregionów...</div>;

    return (
        <div style={{
            fontFamily: "sans-serif",
            position: "relative",
            height: "700px",
            backgroundColor: "#f8fafc",
            border: '1px solid rgb(189 189 189)',
            borderRadius: "5px",
            marginTop: '10px'
        }}>
            <div style={{
                position: "absolute",
                top: "10px",
                left: "10px",
                background: "white",
                padding: "16px",
                borderRadius: "12px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                zIndex: 1000,
                minWidth: "350px"
            }}>
                <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "12px" }}>
                    Powiatów: {polandPowiatFeatures.length}
                </div>

                {selectedSubregion && (
                    <div style={{
                        marginBottom: "12px", padding: "8px",
                        backgroundColor: `${SUBREGIONS[selectedSubregion].color}10`,
                        borderRadius: "6px", borderLeft: `4px solid ${SUBREGIONS[selectedSubregion].color}`
                    }}>
                        <div style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: SUBREGIONS[selectedSubregion].color,
                            marginBottom: "4px"
                        }}>
                            {SUBREGIONS[selectedSubregion].name}
                        </div>
                    </div>
                )}

                <div style={{
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                }}>
                    Wybrany powiat:
                    <span style={{ fontWeight: 600, color: "#1f2937" }}>
                        {selectedPowiatName || "brak"}
                    </span>
                </div>
            </div>

            <ComposableMap
                projection="geoMercator"
                projectionConfig={{ scale: 4000, center: [19.1, 53.2] }}
                style={{ width: "100%", height: "100%" }}
            >
                <Geographies geography={geoData}>
                    {({ geographies }) =>
                        geographies.map((geo) => {
                            const name = getPowiatName(geo.properties);
                            const featureId = getPowiatId(geo.properties);
                            const centroid = geoCentroid(geo);
                            const inSubregion = isInSelectedSubregionSpatially(geo);

                            const isSelected = selectedPowiatId === featureId;
                            const isHovered = hoveredPowiatId === featureId;

                            // console.log('Rendering:', name, 'id:', featureId, 'isSelected:', isSelected);

                            return (
                                <React.Fragment key={featureId}>
                                    <Geography
                                        geography={geo}
                                        fill={
                                            isSelected ? "#1e40af" :
                                                isHovered ? "#3b82f6" :
                                                    inSubregion ? SUBREGIONS[selectedSubregion]?.color : "#f9fafb"
                                        }
                                        stroke={
                                            isSelected ? "#1e3a8a" :
                                                isHovered ? "#2563eb" :
                                                    inSubregion ? (SUBREGIONS[selectedSubregion]?.color || "#d1d5db") : "#e5e7eb"
                                        }
                                        strokeWidth={
                                            isSelected ? 2.5 :
                                                isHovered ? 1.8 :
                                                    inSubregion ? .2 : 1
                                        }
                                        style={{
                                            default: { outline: "none" },
                                            hover: { outline: "none" },
                                            pressed: { outline: "none" },
                                        }}
                                        onClick={() => {
                                            setSelectedPowiatId(featureId);
                                            setSelectedPowiatName(name);
                                            const subKey = getSubregionFromPowiat(name);
                                            setSelectedSubregion(subKey);
                                            if (subKey) {
                                                const center = turf.centerOfMass(geo);
                                                setSubregionCenter(center);
                                            }
                                        }}
                                        onMouseEnter={() => setHoveredPowiatId(featureId)}
                                        onMouseLeave={() => setHoveredPowiatId(null)}
                                    />

                                    {/* {isSelected && centroid && (
                                        <Annotation subject={centroid} dx={0} dy={-18}>
                                            <text
                                                x={0} y={0} textAnchor="middle"
                                                style={{
                                                    fontSize: 13, fill: "#ffffff", fontWeight: "bold",
                                                    stroke: "#1e3a8a", strokeWidth: 2,
                                                    pointerEvents: "none",
                                                    filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.4))"
                                                }}
                                            >
                                                {name.replace('powiat ', '').replace(/-\w+/g, m => m.charAt(0).toUpperCase() + m.slice(1))}
                                            </text>
                                        </Annotation>
                                    )} */}
                                </React.Fragment>
                            );
                        })
                    }
                </Geographies>
            </ComposableMap>
        </div>
    );
}



// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";
// import * as turf from '@turf/turf';

// const SUBREGIONS = {
//     lubelskie: {
//         name: "Subregion lubelski",
//         color: "#dc2626",
//         powiats: [
//             "Lublin", "powiat lubelski", "powiat świdnicki",
//             "powiat lubartowski", "powiat łęczyński"
//         ]
//     },
//     bialski: {
//         name: "Subregion bialski",
//         color: "#ea580c",
//         powiats: [
//             "Biała Podlaska", "powiat bialski", "powiat radzyński",
//             "powiat parczewski", "powiat włodawski"
//         ]
//     },
//     chelmsko_zamojski: {
//         name: "Subregion chełmsko-zamojski",
//         color: "#059669",
//         powiats: [
//             "Chełm", "Zamość", "powiat chełmski", "powiat zamojski",
//             "powiat hrubieszowski", "powiat biłgorajski",
//             "powiat tomaszowski", "powiat krasnostawski"
//         ]
//     },
//     pulawski: {
//         name: "Subregion puławski",
//         color: "#3b82f6",
//         powiats: [
//             "powiat puławski", "powiat łukowski", "powiat rycki",
//             "powiat opolski", "powiat kraśnicki", "powiat janowski"
//         ]
//     }
// };

// export default function SelectionMap({ location }) {
//     const [geoData, setGeoData] = useState(null);
//     const [selectedPowiat, setSelectedPowiat] = useState(null);
//     const [hoveredPowiat, setHoveredPowiat] = useState(null);
//     const [selectedSubregion, setSelectedSubregion] = useState(null);
//     const [subregionCenter, setSubregionCenter] = useState(null);
//     const [polandPowiatFeatures, setPolandPowiatFeatures] = useState([]);

//     const SUBREGION_MAX_DISTANCE_KM = 120; // Dostosuj po testach

//     useEffect(() => {
//         fetch("/powiaty.geojson")
//             .then((res) => res.json())
//             .then((data) => {
//                 const plFeatures = data.features.filter(f =>
//                     f.properties?.nazwa &&
//                     f.properties.nazwa.toLowerCase().includes('powiat')
//                 );
//                 console.log(`Znaleziono ${plFeatures.length} powiatów`);
//                 setPolandPowiatFeatures(plFeatures);
//                 setGeoData({ type: "FeatureCollection", features: plFeatures });
//             })
//             .catch((err) => console.error("Błąd:", err));
//     }, []);

//     useEffect(() => {
//         const selectPowiatFromLocation = async () => {
//             if (!location?.county || !polandPowiatFeatures.length) return;

//             const query = `${location.county} powiat ${location.voivodeship} Poland`;
//             try {
//                 const res = await fetch(
//                     `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=3&countrycodes=pl&addressdetails=1`
//                 );
//                 const geoResults = await res.json();

//                 for (const geo of geoResults) {
//                     const point = turf.point([parseFloat(geo.lon), parseFloat(geo.lat)]);
//                     const powiatFeature = polandPowiatFeatures.find(f => turf.booleanPointInPolygon(point, f));
//                     if (powiatFeature) {
//                         const name = getPowiatName(powiatFeature.properties);
//                         setSelectedPowiat(name);
//                         const subregion = getSubregionFromPowiat(name);
//                         if (subregion) {
//                             setSelectedSubregion(subregion);
//                             // Ustaw centrum subregionu na podstawie znalezionego powiatu
//                             const center = turf.centerOfMass(powiatFeature);
//                             setSubregionCenter(center);
//                         }
//                         return;
//                     }
//                 }
//             } catch (err) {
//                 console.error("Błąd geokodowania:", err);
//             }
//         };

//         selectPowiatFromLocation();
//     }, [location, polandPowiatFeatures]);

//     const getPowiatName = (properties) => {
//         return properties.nazwa?.toLowerCase() || properties.NAME?.toLowerCase() || "";
//     };

//     const getSubregionFromPowiat = (powiatName) => {
//         const lowerName = powiatName.toLowerCase();
//         for (const [key, subregion] of Object.entries(SUBREGIONS)) {
//             if (subregion.powiats.some(powiat =>
//                 lowerName.includes(powiat.toLowerCase()) ||
//                 lowerName === powiat.toLowerCase()
//             )) {
//                 return key;
//             }
//         }
//         return null;
//     };

//     const isInSelectedSubregionSpatially = (feature) => {
//         if (!selectedSubregion || !subregionCenter) return false;

//         const name = getPowiatName(feature.properties);
//         const subKey = getSubregionFromPowiat(name);
//         if (subKey !== selectedSubregion) return false;

//         // Sprawdź dystans przestrzenny od centrum subregionu
//         const centroid = turf.centroid(feature);
//         const dist = turf.distance(subregionCenter, centroid, { units: "kilometers" });

//         return dist <= SUBREGION_MAX_DISTANCE_KM;
//     };

//     if (!geoData) return <div>Ładowanie mapy subregionów...</div>;

//     return (
//         <div style={{
//             fontFamily: "sans-serif",
//             position: "relative",
//             height: "700px",
//             backgroundColor: "#f8fafc"
//         }}>
//             {/* Panel sterowania */}
//             <div style={{
//                 position: "absolute",
//                 top: "10px",
//                 left: "10px",
//                 background: "white",
//                 padding: "16px",
//                 borderRadius: "12px",
//                 boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//                 zIndex: 1000,
//                 minWidth: "350px"
//             }}>
//                 <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "12px" }}>
//                     Powiatów: {polandPowiatFeatures.length}
//                 </div>

//                 {selectedSubregion && (
//                     <div style={{
//                         marginBottom: "12px", padding: "8px",
//                         backgroundColor: `${SUBREGIONS[selectedSubregion].color}10`,
//                         borderRadius: "6px", borderLeft: `4px solid ${SUBREGIONS[selectedSubregion].color}`
//                     }}>
//                         <div style={{
//                             fontSize: "14px",
//                             fontWeight: 600,
//                             color: SUBREGIONS[selectedSubregion].color,
//                             marginBottom: "4px"
//                         }}>
//                             {SUBREGIONS[selectedSubregion].name}
//                         </div>
//                         {/* <div style={{ fontSize: "12px", color: "#374151" }}>
//                             `Tylko powiaty w subregionie oznaczone kolorem (dystans < {SUBREGION_MAX_DISTANCE_KM} km)``
//                         </div> */}
//                     </div>
//                 )}

//                 <div style={{
//                     fontSize: "13px",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px"
//                 }}>
//                     Wybrany powiat:
//                     <span style={{ fontWeight: 600, color: "#1f2937" }}>
//                         {selectedPowiat || "brak"}
//                     </span>
//                 </div>
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{ scale: 4000, center: [19.1, 53.2] }}
//                 style={{ width: "100%", height: "100%" }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = getPowiatName(geo.properties);
//                             const centroid = geoCentroid(geo);
//                             const inSubregion = isInSelectedSubregionSpatially(geo);
//                             const lowerName = name.toLowerCase();

//                             return (
//                                 <React.Fragment key={geo.rsmKey}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={
//                                             selectedPowiat === lowerName ? "#1e40af" :
//                                                 hoveredPowiat === lowerName ? "#3b82f6" :
//                                                     inSubregion ? "#dbeafe" : "#f9fafb"
//                                         }
//                                         stroke={
//                                             selectedPowiat === lowerName ? "#1e3a8a" :
//                                                 hoveredPowiat === lowerName ? "#2563eb" :
//                                                     inSubregion ? (SUBREGIONS[selectedSubregion]?.color || "#d1d5db") : "#e5e7eb"
//                                         }
//                                         // strokeWidth={
//                                         //     selectedPowiat === lowerName ? 3 :
//                                         //         hoveredPowiat === lowerName ? 2 :
//                                         //             inSubregion ? 2 : 1
//                                         // }
//                                         strokeWidth={
//                                             selectedPowiat === lowerName ? 2.5 :
//                                                 hoveredPowiat === lowerName ? 1.8 :
//                                                     .2  // zawsze cienka linia dla subregionu
//                                         }


//                                         style={{
//                                             default: { outline: "none" },
//                                             hover: { outline: "none" },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => {
//                                             setSelectedPowiat(lowerName);
//                                             const subKey = getSubregionFromPowiat(lowerName);
//                                             setSelectedSubregion(subKey);
//                                             if (subKey) {
//                                                 const center = turf.centerOfMass(geo);
//                                                 setSubregionCenter(center);
//                                             }
//                                         }}
//                                         onMouseEnter={() => setHoveredPowiat(lowerName)}
//                                         onMouseLeave={() => setHoveredPowiat(null)}
//                                     />

//                                     {selectedPowiat === lowerName && centroid && (
//                                         <Annotation subject={centroid} dx={0} dy={-18}>
//                                             <text
//                                                 x={0} y={0} textAnchor="middle"
//                                                 style={{
//                                                     fontSize: 13, fill: "#ffffff", fontWeight: "bold",
//                                                     stroke: "#1e3a8a", strokeWidth: 2,
//                                                     pointerEvents: "none",
//                                                     filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.4))"
//                                                 }}
//                                             >
//                                                 {name.replace('powiat ', '').replace(/-\w+/g, m => m.charAt(0).toUpperCase() + m.slice(1))}
//                                             </text>
//                                         </Annotation>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>
//         </div>
//     );
// }




// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";
// import * as turf from '@turf/turf';

// export default function SelectionMap({ location }) {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const [hovered, setHovered] = useState(null);
//     const [polandFeatures, setPolandFeatures] = useState([]);

//     useEffect(() => {
//         fetch("/powiaty.geojson")
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log("Przykładowe properties:", data.features[0]?.properties);
//                 // Filtrujemy tylko polskie powiaty używając pola 'nazwa'
//                 const plFeatures = data.features.filter(f =>
//                     f.properties?.nazwa &&
//                     f.properties.nazwa.toLowerCase().includes('powiat')
//                 );
//                 console.log(`Znaleziono ${plFeatures.length} powiatów`);
//                 setPolandFeatures(plFeatures);
//                 setGeoData({ type: "FeatureCollection", features: plFeatures });
//             })
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     useEffect(() => {
//         const selectPowiatFromLocation = async () => {
//             if (!location?.county || !polandFeatures.length) return;

//             const query = `${location.county} powiat ${location.voivodeship} Poland`;
//             console.log("Auto-wyszukiwanie powiatu:", query);

//             try {
//                 const res = await fetch(
//                     `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=3&countrycodes=pl&addressdetails=1`
//                 );
//                 const geoResults = await res.json();

//                 for (const geo of geoResults) {
//                     const point = turf.point([parseFloat(geo.lon), parseFloat(geo.lat)]);
//                     const powiatFeature = polandFeatures.find(f => turf.booleanPointInPolygon(point, f));
//                     if (powiatFeature) {
//                         const name = getName(powiatFeature.properties);
//                         setSelected(name);
//                         console.log(`Auto-wybrano: ${name}`);
//                         return;
//                     }
//                 }
//             } catch (err) {
//                 console.error("Błąd geokodowania:", err);
//             }
//         };

//         selectPowiatFromLocation();
//     }, [location, polandFeatures]);

//     if (!geoData) return <div>Ładowanie mapy powiatów... ({polandFeatures.length} powiatów)</div>;

//     const getName = (properties) => {
//         return properties.nazwa ||
//             properties.NAME ||
//             properties.name ||
//             `Powiat ${properties.id}` ||
//             "Powiat";
//     };

//     const getFill = (name) =>
//         selected === name ? "#2563eb" :
//             hovered === name ? "#3b82f6" :
//                 "#f3f4f6";  // Bardzo jasne tło

//     const handleGeographyClick = (geo) => {
//         const name = getName(geo.properties);
//         setSelected(name);
//         console.log("Kliknięto:", name);
//     };

//     const handleGeographyHover = (geo) => {
//         const name = getName(geo.properties);
//         setHovered(name);
//     };

//     return (
//         <div style={{
//             fontFamily: "sans-serif",
//             position: "relative",
//             height: "650px",
//             backgroundColor: "#f8fafc"
//         }}>
//             <div style={{
//                 position: "absolute",
//                 top: "10px",
//                 left: "10px",
//                 background: "white",
//                 padding: "8px 12px",
//                 borderRadius: "6px",
//                 fontSize: "12px",
//                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
//             }}>
//                 Powiatów: {polandFeatures.length} |
//                 Wybrany: {selected || "brak"}
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{
//                     scale: 4300,
//                     center: [19.1, 52]
//                 }}
//                 style={{ width: "100%", height: "100%" }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = getName(geo.properties);
//                             const centroid = geoCentroid(geo);

//                             return (
//                                 <g key={geo.rsmKey || geo.properties?.id}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={getFill(name)}
//                                         stroke="#d1d5db"
//                                         strokeWidth={1}
//                                         style={{
//                                             default: {
//                                                 outline: "none",
//                                                 strokeLinecap: "round",
//                                                 strokeLinejoin: "round",
//                                             },
//                                             hover: {
//                                                 outline: "none",
//                                                 strokeWidth: 1.5
//                                             },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => handleGeographyClick(geo)}
//                                         onMouseEnter={() => handleGeographyHover(geo)}
//                                         onMouseLeave={() => setHovered(null)}
//                                     />
//                                     {/* Etykieta dla wybrango powiatu */}
//                                     {/* {selected === name && centroid && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={-15}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 style={{
//                                                     fontSize: 12,
//                                                     fill: "#2563eb",
//                                                     fontWeight: "bold",
//                                                     textShadow: "1px 1px 2px rgba(255,255,255,0.8)"
//                                                 }}
//                                             >
//                                                 {name.replace('powiat ', '')}
//                                             </text>
//                                         </Annotation>
//                                     )} */}
//                                     {/* Mała etykieta przy hover */}
//                                     {/* {hovered === name && centroid && selected !== name && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={-10}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 style={{
//                                                     fontSize: 10,
//                                                     fill: "#3b82f6",
//                                                     fontWeight: "500"
//                                                 }}
//                                             >
//                                                 {name.split(' ')[1] || name}
//                                             </text>
//                                         </Annotation>
//                                     )} */}
//                                 </g>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>

//             {/* Panel wybranego powiatu */}
//             {selected && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: "50px",
//                         left: "10px",
//                         backgroundColor: "white",
//                         padding: "16px 20px",
//                         borderRadius: "12px",
//                         boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
//                         border: "3px solid #2563eb",
//                         maxWidth: "380px",
//                         zIndex: 10
//                     }}
//                 >
//                     <div style={{
//                         display: "flex",
//                         alignItems: "center",
//                         marginBottom: "8px"
//                     }}>
//                         <div style={{
//                             width: "12px",
//                             height: "12px",
//                             backgroundColor: "#2563eb",
//                             borderRadius: "50%",
//                             marginRight: "8px"
//                         }} />
//                         <span style={{ fontSize: "14px", color: "#2563eb", fontWeight: 600 }}>
//                             Wybrany powiat
//                         </span>
//                     </div>
//                     <h3 style={{
//                         margin: "0 0 8px 0",
//                         color: "#1f2937",
//                         fontSize: "18px"
//                     }}>
//                         {selected}
//                     </h3>
//                     <div style={{
//                         fontSize: "13px",
//                         color: "#6b7280"
//                     }}>
//                         Kliknij na inne powiaty aby zmienić wybór
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }




// NUTS 3

// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";
// import * as turf from '@turf/turf';

// export default function SelectionMap({ location }) {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const [hovered, setHovered] = useState(null);
//     const [polandFeatures, setPolandFeatures] = useState([]);

//     useEffect(() => {
//         fetch("/powiaty.geojson")
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log("Przykładowe properties NUTS:", data.features[0]?.properties);
//                 const plFeatures = data.features.filter(f =>
//                     f.properties?.CNTR_CODE === "PL" ||
//                     f.properties?.NUTS_ID?.startsWith("PL")
//                 );
//                 setPolandFeatures(plFeatures);
//                 setGeoData({ type: "FeatureCollection", features: plFeatures });
//             })
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     useEffect(() => {
//         const selectNutsFromLocation = async () => {
//             if (!location?.county || !polandFeatures.length) return;

//             const query = `${location.county} powiat ${location.voivodeship} Poland`;
//             console.log("Auto-wyszukiwanie NUTS3:", query);

//             try {
//                 const res = await fetch(
//                     `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=3&countrycodes=pl&addressdetails=1`
//                 );
//                 const geoResults = await res.json();

//                 for (const geo of geoResults) {
//                     const point = turf.point([parseFloat(geo.lon), parseFloat(geo.lat)]);
//                     const nutsFeature = polandFeatures.find(f => turf.booleanPointInPolygon(point, f));
//                     if (nutsFeature) {
//                         const name = getName(nutsFeature.properties);
//                         setSelected(name);
//                         console.log(`Auto-wybrano: ${name} dla ${query}`);
//                         return;
//                     }
//                 }
//                 console.log("Brak NUTS3 dla:", query);
//             } catch (err) {
//                 console.error("Błąd geokodowania:", err);
//             }
//         };

//         selectNutsFromLocation();
//     }, [location, polandFeatures]);


//     if (!geoData) return <div>Ładowanie mapy NUTS...</div>;

//     const getName = (properties) => {
//         return properties.NUTS_NAME ||
//             properties.NAME_LATN ||
//             properties.NAME ||
//             properties.NUTS_ID ||
//             "NUTS Region";
//     };

//     const getFill = (name) =>
//         selected === name ? "#2563eb" : hovered === name ? "#3b82f6" : "#60a5fa";


//     return (
//         <div style={{ display: "flex", fontFamily: "sans-serif", position: "relative" }}>
//             <div style={{ width: "250px", marginRight: "1rem" }}>
//                 <h3>Regiony NUTS 3 (PL)</h3>
//                 <div style={{ maxHeight: "600px", overflowY: "auto" }}>
//                     <ul style={{ listStyle: "none", padding: 0 }}>
//                         {polandFeatures.map((f, index) => {
//                             const name = getName(f.properties);
//                             return (
//                                 <li
//                                     key={f.properties?.NUTS_ID || index}
//                                     onClick={() => setSelected(name)}
//                                     onMouseEnter={() => setHovered(name)}
//                                     onMouseLeave={() => setHovered(null)}
//                                     style={{
//                                         cursor: "pointer",
//                                         margin: "2px 0",
//                                         fontSize: "12px",
//                                         fontWeight: selected === name ? "bold" : "normal",
//                                         color: selected === name ? "#2563eb" : "#000",
//                                     }}
//                                 >
//                                     {name} ({f.properties?.NUTS_ID || "PL*"})
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </div>
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{ scale: 4000, center: [19, 52] }}
//                 style={{ width: "100%", height: "600px", flex: 1 }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = getName(geo.properties);
//                             const centroid = geoCentroid(geo);

//                             return (
//                                 <React.Fragment key={geo.rsmKey || geo.properties?.NUTS_ID}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={getFill(name)}
//                                         stroke="#1f2937"
//                                         strokeWidth={selected === name ? 2 : 0.5}
//                                         style={{
//                                             default: {
//                                                 outline: "none",
//                                                 strokeLinecap: "round",
//                                                 strokeLinejoin: "round",
//                                             },
//                                             hover: { outline: "none" },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => setSelected(name)}
//                                         onMouseEnter={() => setHovered(name)}
//                                         onMouseLeave={() => setHovered(null)}
//                                     />
//                                     {selected === name && centroid && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={-5}
//                                             connectorProps={{ stroke: "#2563eb", strokeWidth: 1 }}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 alignmentBaseline="middle"
//                                                 style={{
//                                                     fontSize: 10,
//                                                     fill: "#2563eb",
//                                                     fontWeight: "bold",
//                                                 }}
//                                             >
//                                                 {name}
//                                             </text>
//                                         </Annotation>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>

//             {selected && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         bottom: "10px",
//                         left: "270px",
//                         backgroundColor: "white",
//                         padding: "8px 12px",
//                         borderRadius: "6px",
//                         fontWeight: "bold",
//                         boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//                         maxWidth: "300px",
//                     }}
//                 >
//                     Wybrany region NUTS 3: <strong>{selected}</strong>
//                 </div>
//             )}
//         </div>
//     );
// }



// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";
// import * as turf from '@turf/turf';


// export default function SelectionMap({ location }) {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const [hovered, setHovered] = useState(null);
//     const [polandFeatures, setPolandFeatures] = useState([]);

//     console.log('location655555', location)

//     useEffect(() => {
//         fetch("/nuts.geojson")
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log("Przykładowe properties NUTS:", data.features[0]?.properties);
//                 const plFeatures = data.features.filter(f =>
//                     f.properties?.CNTR_CODE === "PL" ||
//                     f.properties?.NUTS_ID?.startsWith("PL")
//                 );
//                 setPolandFeatures(plFeatures);
//                 setGeoData({ type: "FeatureCollection", features: plFeatures });
//             })
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     if (!geoData) return <div>Ładowanie mapy NUTS...</div>;

//     const getName = (properties) => {
//         return properties.NUTS_NAME ||
//             properties.NAME_LATN ||
//             properties.NAME ||
//             properties.NUTS_ID ||
//             "NUTS Region";
//     };

//     const getFill = (name) =>
//         selected === name ? "#2563eb" : hovered === name ? "#3b82f6" : "#60a5fa";


//     // Funkcja mapowania danych → NUTS3:
//     const selectNutsFromLocation = async () => {
//         if (!location?.county) return;

//         // Query precyzyjne: powiat + voivodeship
//         const query = `${location.county} powiat ${location.voivodeship} Poland`;
//         console.log("Szukam:", query);

//         const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=3&countrycodes=pl&addressdetails=1`);
//         const geoResults = await res.json();

//         for (const geo of geoResults) {
//             const point = turf.point([parseFloat(geo.lon), parseFloat(geo.lat)]);
//             const nutsFeature = polandFeatures.find(f => turf.booleanPointInPolygon(point, f));
//             if (nutsFeature) {
//                 const name = getName(nutsFeature.properties);
//                 setSelected(name);
//                 console.log(`Znaleziono: ${name} dla ${query}`);
//                 return;
//             }
//         }
//         console.log("Brak NUTS3 dla:", query);
//     };


//     return (
//         <div style={{ display: "flex", fontFamily: "sans-serif", position: "relative" }}>


//             {location && (
//                 <div style={{ background: "#ecfdf5", padding: "12px", borderRadius: "6px", marginBottom: "15px" }}>
//                     <h4>Dane lokalizacji:</h4>
//                     <p><strong>Gmina:</strong> {location.municipality}</p>
//                     <p><strong>Powiat:</strong> {location.county}</p>
//                     <p><strong>Województwo:</strong> {location.voivodeship}</p>
//                     <button
//                         onClick={selectNutsFromLocation}
//                         style={{
//                             marginTop: "8px",
//                             padding: "8px 16px",
//                             background: "#10b981",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "4px",
//                             cursor: "pointer"
//                         }}
//                     >
//                         Wybierz NUTS3 dla tej lokalizacji
//                     </button>
//                 </div>
//             )}


//             <div style={{ width: "250px", marginRight: "1rem" }}>
//                 <h3>Regiony NUTS 3 (PL)</h3>
//                 <div style={{ maxHeight: "600px", overflowY: "auto" }}>
//                     <ul style={{ listStyle: "none", padding: 0 }}>
//                         {polandFeatures.map((f, index) => {
//                             const name = getName(f.properties);
//                             return (
//                                 <li
//                                     key={f.properties?.NUTS_ID || index}
//                                     onClick={() => setSelected(name)}
//                                     onMouseEnter={() => setHovered(name)}
//                                     onMouseLeave={() => setHovered(null)}
//                                     style={{
//                                         cursor: "pointer",
//                                         margin: "2px 0",
//                                         fontSize: "12px",
//                                         fontWeight: selected === name ? "bold" : "normal",
//                                         color: selected === name ? "#2563eb" : "#000",
//                                     }}
//                                 >
//                                     {name} ({f.properties?.NUTS_ID || "PL*"})
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </div>
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{ scale: 4000, center: [19, 52] }}
//                 style={{ width: "100%", height: "600px", flex: 1 }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = getName(geo.properties);
//                             const centroid = geoCentroid(geo);

//                             return (
//                                 <React.Fragment key={geo.rsmKey || geo.properties?.NUTS_ID}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={getFill(name)}
//                                         stroke="#1f2937"
//                                         strokeWidth={selected === name ? 2 : 0.5}
//                                         style={{
//                                             default: {
//                                                 outline: "none",
//                                                 strokeLinecap: "round",
//                                                 strokeLinejoin: "round",
//                                             },
//                                             hover: { outline: "none" },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => setSelected(name)}
//                                         onMouseEnter={() => setHovered(name)}
//                                         onMouseLeave={() => setHovered(null)}
//                                     />
//                                     {selected === name && centroid && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={-5}
//                                             connectorProps={{ stroke: "#2563eb", strokeWidth: 1 }}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 alignmentBaseline="middle"
//                                                 style={{
//                                                     fontSize: 10,
//                                                     fill: "#2563eb",
//                                                     fontWeight: "bold",
//                                                 }}
//                                             >
//                                                 {name}
//                                             </text>
//                                         </Annotation>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>

//             {selected && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         bottom: "10px",
//                         left: "270px",
//                         backgroundColor: "white",
//                         padding: "8px 12px",
//                         borderRadius: "6px",
//                         fontWeight: "bold",
//                         boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//                         maxWidth: "300px",
//                     }}
//                 >
//                     Wybrany region NUTS 3: <strong>{selected}</strong>
//                 </div>
//             )}
//         </div>
//     );
// }







// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";

// export default function SelectionMap() {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const [hovered, setHovered] = useState(null);

//     useEffect(() => {
//         fetch("/wojewodztwa.geojson")  // Zmień na Twój plik lub URL CDN/raw GitHub
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log("Properties przykład:", data.features[0]?.properties); // Debug
//                 setGeoData(data);
//             })
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     if (!geoData) return <div>Ładowanie mapy...</div>;

//     // Funkcja do bezpiecznego pobierania nazwy województwa
//     const getName = (properties) => {
//         return properties.JPT_NAZWA_ ||
//             properties.NAME_1 ||
//             properties.NAME_POLISH ||
//             properties.nazwa ||
//             properties.name ||
//             "Region"; // Fallback
//     };

//     const getFill = (name) =>
//         selected === name ? "#2563eb" : hovered === name ? "#3b82f6" : "#60a5fa";

//     return (
//         <div style={{ display: "flex", fontFamily: "sans-serif", position: "relative" }}>
//             <div style={{ width: "200px", marginRight: "1rem" }}>
//                 <h3>Województwa</h3>
//                 <ul style={{ listStyle: "none", padding: 0 }}>
//                     {geoData.features.map((f, index) => {
//                         const name = getName(f.properties);
//                         return (
//                             <li
//                                 key={name || index}
//                                 onClick={() => setSelected(name)}
//                                 onMouseEnter={() => setHovered(name)}
//                                 onMouseLeave={() => setHovered(null)}
//                                 style={{
//                                     cursor: "pointer",
//                                     margin: "4px 0",
//                                     fontWeight: selected === name ? "bold" : "normal",
//                                     color: selected === name ? "#2563eb" : "#000",
//                                 }}
//                             >
//                                 {name}
//                             </li>
//                         );
//                     })}
//                 </ul>
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{ scale: 4000, center: [19, 52] }}
//                 style={{ width: "100%", height: "600px" }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = getName(geo.properties);
//                             const centroid = geoCentroid(geo);

//                             return (
//                                 <React.Fragment key={geo.rsmKey}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={getFill(name)}
//                                         stroke="#1f2937"
//                                         strokeWidth={selected === name ? 3 : 1}
//                                         style={{
//                                             default: {
//                                                 outline: "none",
//                                                 strokeLinecap: "square",
//                                                 strokeLinejoin: "miter",
//                                             },
//                                             hover: { outline: "none" },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => setSelected(name)}
//                                         onMouseEnter={() => setHovered(name)}
//                                         onMouseLeave={() => setHovered(null)}
//                                     />
//                                     {selected === name && centroid && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={0}
//                                             connectorProps={{ stroke: "transparent" }}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 alignmentBaseline="middle"
//                                                 style={{
//                                                     fontSize: 12,
//                                                     fill: "#000",
//                                                     fontWeight: "bold",
//                                                 }}
//                                             >
//                                                 {name}
//                                             </text>
//                                         </Annotation>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>

//             {selected && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         bottom: "10px",
//                         left: "220px",
//                         backgroundColor: "white",
//                         padding: "4px 8px",
//                         borderRadius: "4px",
//                         fontWeight: "bold",
//                         boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
//                     }}
//                 >
//                     Wybrane województwo: {selected}
//                 </div>
//             )}
//         </div>
//     );
// }



// import React, { useEffect, useState } from "react";
// import {
//     ComposableMap,
//     Geographies,
//     Geography,
//     Annotation,
// } from "react-simple-maps";
// import { geoCentroid } from "d3-geo";

// export default function SelectionMap() {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const [hovered, setHovered] = useState(null);

//     useEffect(() => {
//         fetch("/wojewodztwa.geojson")
//             .then((res) => res.json())
//             .then((data) => setGeoData(data))
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     if (!geoData) return <div>Ładowanie mapy...</div>;

//     const getFill = (name) =>
//         selected === name ? "#2563eb" : hovered === name ? "#3b82f6" : "#60a5fa";


//     geoData.features.map((f) => {
//         console.log('ggggggggggggggggggggg', f.properties);
//     });

//     return (
//         <div style={{ display: "flex", fontFamily: "sans-serif" }}>
//             <div style={{ width: "200px", marginRight: "1rem" }}>
//                 <h3>Województwa</h3>
//                 <ul style={{ listStyle: "none", padding: 0 }}>
//                     {geoData.features.map((f) => (
//                         <li
//                             key={f.properties.JPT_NAZWA_}
//                             onClick={() => setSelected(f.properties.JPT_NAZWA_)}
//                             onMouseEnter={() => setHovered(f.properties.JPT_NAZWA_)}
//                             onMouseLeave={() => setHovered(null)}
//                             style={{
//                                 cursor: "pointer",
//                                 margin: "4px 0",
//                                 fontWeight:
//                                     selected === f.properties.JPT_NAZWA_ ? "bold" : "normal",
//                                 color: selected === f.properties.JPT_NAZWA_ ? "#2563eb" : "#000",
//                             }}
//                         >
//                             {f.properties.JPT_NAZWA_}
//                         </li>
//                     ))}
//                 </ul>
//             </div>

//             <ComposableMap
//                 projection="geoMercator"
//                 projectionConfig={{ scale: 4000, center: [19, 52] }}
//                 style={{ width: "100%", height: "600px" }}
//             >
//                 <Geographies geography={geoData}>
//                     {({ geographies }) =>
//                         geographies.map((geo) => {
//                             const name = geo.properties.JPT_NAZWA_;
//                             const centroid = geoCentroid(geo);

//                             return (
//                                 <React.Fragment key={geo.rsmKey}>
//                                     <Geography
//                                         geography={geo}
//                                         fill={getFill(name)}
//                                         stroke="#1f2937"
//                                         strokeWidth={selected === name ? 3 : 1}
//                                         style={{
//                                             default: {
//                                                 outline: "none",
//                                                 strokeLinecap: "square",
//                                                 strokeLinejoin: "miter",
//                                             },
//                                             hover: { outline: "none" },
//                                             pressed: { outline: "none" },
//                                         }}
//                                         onClick={() => setSelected(name)}
//                                         onMouseEnter={() => setHovered(name)}
//                                         onMouseLeave={() => setHovered(null)}
//                                     />
//                                     {selected === name && centroid && (
//                                         <Annotation
//                                             subject={centroid}
//                                             dx={0}
//                                             dy={0}
//                                             connectorProps={{ stroke: "transparent" }}
//                                         >
//                                             <text
//                                                 x={0}
//                                                 y={0}
//                                                 textAnchor="middle"
//                                                 alignmentBaseline="middle"
//                                                 style={{
//                                                     fontSize: 12,
//                                                     fill: "#000",
//                                                     fontWeight: "bold",
//                                                 }}
//                                             >
//                                                 {name}
//                                             </text>
//                                         </Annotation>
//                                     )}
//                                 </React.Fragment>
//                             );
//                         })
//                     }
//                 </Geographies>
//             </ComposableMap>

//             {selected && (
//                 <div
//                     style={{
//                         position: "absolute",
//                         bottom: "10px",
//                         left: "220px",
//                         backgroundColor: "white",
//                         padding: "4px 8px",
//                         borderRadius: "4px",
//                         fontWeight: "bold",
//                         boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
//                     }}
//                 >
//                     Wybrane województwo: {selected}
//                 </div>
//             )}
//         </div>
//     );
// }


// import React, { useState, useEffect, useRef } from "react";
// import { MapContainer, GeoJSON, useMap } from "react-leaflet";
// import L from "leaflet";

// function FitBounds({ geoData, map }) {
//     useEffect(() => {
//         if (geoData && map) {
//             const layer = L.geoJSON(geoData);
//             console.log("FitBounds layer bounds:", layer.getBounds());
//             map.fitBounds(layer.getBounds(), { animate: true, duration: 1.0 });
//         }
//     }, [geoData, map]);
//     return null;
// }

// export default function SelectionMap() {
//     const [geoData, setGeoData] = useState(null);
//     const [selected, setSelected] = useState(null);
//     const geoJsonRef = useRef(null);
//     const mapRef = useRef(null);

//     useEffect(() => {
//         fetch("/wojewodztwa.geojson")
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log("GeoJSON loaded:", data);
//                 setGeoData(data);
//             })
//             .catch((err) => console.error("Błąd wczytywania GeoJSON:", err));
//     }, []);

//     const getStyle = (name) => ({
//         fillColor: selected === name ? "#2563eb" : "#60a5fa",
//         weight: 2,
//         color: "#1f2937",
//         fillOpacity: 0.4,
//     });

//     const highlightStyle = { weight: 3, fillOpacity: 0.7 };

//     const onMapLoad = (map) => {
//         mapRef.current = map;
//         console.log("Map loaded:", map);
//         map.dragging.disable();
//         map.on("zoomend", () => {
//             console.log("Zoom changed:", map.getZoom());
//             if (map.getZoom() > 6) map.dragging.enable();
//             else map.dragging.disable();
//         });
//     };

//     const selectRegion = (name) => {
//         console.log("Selecting region:", name);
//         setSelected(name);
//         if (geoJsonRef.current) {
//             geoJsonRef.current.eachLayer((layer) => {
//                 if (layer instanceof L.LayerGroup) {
//                     layer.eachLayer((sub) => {
//                         console.log("Updating sub-layer style:", sub.feature.properties.JPT_NAZWA_);
//                         sub.setStyle({
//                             fillColor: sub.feature.properties.JPT_NAZWA_ === name ? "#2563eb" : "#60a5fa",
//                             color: "#1f2937",
//                             weight: 2,
//                             fillOpacity: 0.4,
//                         });
//                     });
//                 } else {
//                     console.log("Updating layer style:", layer.feature.properties.JPT_NAZWA_);
//                     layer.setStyle({
//                         fillColor: layer.feature.properties.JPT_NAZWA_ === name ? "#2563eb" : "#60a5fa",
//                         color: "#1f2937",
//                         weight: 2,
//                         fillOpacity: 0.4,
//                     });
//                 }
//             });
//         }

//         // Płynne przybliżenie do wybranego województwa
//         if (mapRef.current) {
//             const targetLayer = geoJsonRef.current
//                 .getLayers()
//                 .find((l) =>
//                     l.feature.properties.JPT_NAZWA_ === name ||
//                     (l instanceof L.LayerGroup &&
//                         l.getLayers().some((sub) => sub.feature.properties.JPT_NAZWA_ === name))
//                 );

//             if (targetLayer) {
//                 const bounds =
//                     targetLayer instanceof L.LayerGroup
//                         ? L.featureGroup(targetLayer.getLayers()).getBounds()
//                         : targetLayer.getBounds();
//                 console.log("Fitting map bounds to:", bounds);
//                 mapRef.current.fitBounds(bounds, { animate: true, duration: 1.0 });
//             }
//         }
//     };

//     // Dodajemy eventy do sub-warstw po załadowaniu GeoJSON
//     useEffect(() => {
//         if (geoData && geoJsonRef.current) {
//             console.log("Attaching eventHandlers to GeoJSON layers");
//             geoJsonRef.current.eachLayer((layer) => {
//                 if (layer instanceof L.LayerGroup) {
//                     layer.eachLayer((sub) => {
//                         sub.on("click", () => {
//                             console.log("Map click sub-layer:", sub.feature.properties.JPT_NAZWA_);
//                             selectRegion(sub.feature.properties.JPT_NAZWA_);
//                         });
//                         sub.on("mouseover", () => {
//                             console.log("Mouseover sub-layer:", sub.feature.properties.JPT_NAZWA_);
//                             sub.setStyle(highlightStyle);
//                         });
//                         sub.on("mouseout", () => {
//                             sub.setStyle(getStyle(sub.feature.properties.JPT_NAZWA_));
//                         });
//                     });
//                 } else {
//                     layer.on("click", () => {
//                         console.log("Map click layer:", layer.feature.properties.JPT_NAZWA_);
//                         selectRegion(layer.feature.properties.JPT_NAZWA_);
//                     });
//                     layer.on("mouseover", () => {
//                         console.log("Mouseover layer:", layer.feature.properties.JPT_NAZWA_);
//                         layer.setStyle(highlightStyle);
//                     });
//                     layer.on("mouseout", () => {
//                         layer.setStyle(getStyle(layer.feature.properties.JPT_NAZWA_));
//                     });
//                 }
//             });
//         }
//     }, [geoData, selected]);

//     if (!geoData) return <div>Ładowanie mapy...</div>;

//     return (
//         <div style={{ display: "flex" }}>
//             {/* Lista województw */}
//             <div style={{ width: "200px", marginRight: "1rem" }}>
//                 <h3>Województwa</h3>
//                 <ul style={{ listStyle: "none", padding: 0 }}>
//                     {geoData.features.map((f) => (
//                         <li
//                             key={f.properties.JPT_NAZWA_}
//                             onClick={() => selectRegion(f.properties.JPT_NAZWA_)}
//                             style={{
//                                 cursor: "pointer",
//                                 margin: "4px 0",
//                                 fontWeight: selected === f.properties.JPT_NAZWA_ ? "bold" : "normal",
//                                 color: selected === f.properties.JPT_NAZWA_ ? "#2563eb" : "#000",
//                             }}
//                         >
//                             {f.properties.JPT_NAZWA_}
//                         </li>
//                     ))}
//                 </ul>
//             </div>

//             {/* Mapa */}
//             <MapContainer
//                 center={[52, 19]}
//                 zoom={6}
//                 style={{ height: "600px", width: "100%" }}
//                 whenCreated={onMapLoad}
//             >
//                 <GeoJSON ref={geoJsonRef} data={geoData} style={(f) => getStyle(f.properties.JPT_NAZWA_)} />
//                 <FitBounds geoData={geoData} map={mapRef.current} />
//             </MapContainer>
//         </div>
//     );
// }